import { useSyncExternalStore } from 'react';

export type DashboardBreakpoint = 'phone' | 'tablet' | 'wide';

// Mirrors the layout breakpoints: phone < 820, tablet 820–1279, wide ≥ 1280.
const WIDE_QUERY = '(min-width: 1280px)';
const TABLET_QUERY = '(min-width: 820px)';

function getSnapshot(): DashboardBreakpoint {
  if (typeof window === 'undefined' || !window.matchMedia) return 'wide';
  if (window.matchMedia(WIDE_QUERY).matches) return 'wide';
  if (window.matchMedia(TABLET_QUERY).matches) return 'tablet';
  return 'phone';
}

function subscribe(callback: () => void): () => void {
  const wide = window.matchMedia(WIDE_QUERY);
  const tablet = window.matchMedia(TABLET_QUERY);
  wide.addEventListener('change', callback);
  tablet.addEventListener('change', callback);
  return () => {
    wide.removeEventListener('change', callback);
    tablet.removeEventListener('change', callback);
  };
}

/**
 * Which of the three fixed dashboard arrangements to render. Backed by
 * matchMedia so it updates on resize/orientation change without polling.
 */
export function useDashboardBreakpoint(): DashboardBreakpoint {
  return useSyncExternalStore(subscribe, getSnapshot, () => 'wide');
}
